module.exports = __webpack_public_path__ + "img/payment.251fb074.svg";